<div class="graphWrapper relative h-full w-full bg-neutral-50">
  @if (!loading()) {
    @if (showBreadcrumb() && breadcrumbs?.length) {
      <div
        (click)="goBackToParent()"
        class="flex flex-row justify-items-center items-center absolute top-24 rounded-2xl px-4 py-2 bg-white left-8 z-20 cursor-pointer"
        tabindex="0"
        data-testid="instance-back-to-parent"
      >
        <i class="ph ph-caret-left mr-2 cursor-pointer"></i>Back to
        <span class="ml-2 font-semibold">{{ breadcrumbs[breadcrumbs.length - 1].name }}</span>
      </div>
    }

    <app-bpmn-editor-node-actions
      [actions]="bpmnInstanceActionsStore.bpmnInstanceActions$ | async"
      [maxWidth]="250"
    ></app-bpmn-editor-node-actions>

    <app-process-instance-details-panel
      [process]="$safeNavigationMigration(applicationProcessData()?.processData)"
      (subprocessNavigation)="
        onSubprocessNavigation(
          $event,
          applicationProcessData()?.processData.definition.resourceName,
          applicationProcessData()?.processData.instance.uuid
        )
      "
      class="process-details-panel overflow-hidden !z-[100]"
    ></app-process-instance-details-panel>
  } @else {
    <div class="flex flex-col h-full w-full items-center justify-center">
      <flx-spinner
        [radius]="90"
        visualType="custom"
        size="custom"
      />
    </div>
  }

  <div
    class="graph-wrapper h-full w-full absolute top-0 left-0"
    data-testid="instance-canvas-diagram"
  >
    <react-wrapper
      [component]="BpmnDiagram"
      [props]="reactProps()"
    ></react-wrapper>
  </div>
</div>
